import './map.scss';
import $ from 'jquery';
import Sloth from '../Sloth';

@Sloth.component({
    defaultOptions: {
        width : 'auto',
        height : 'auto',
        sw : 121.557634,
        ne : 38.884033,
        zoom : 17,
        mark : ''
    }
})

export default class Map {
    onInit() {
        const ComplexCustomOverlay = (point, text, mouseoverText) => {
            this._point = point;
            this._text = text;
            this._overText = mouseoverText;
        };
        ComplexCustomOverlay.prototype = new BMap.Overlay();
        ComplexCustomOverlay.prototype.initialize = (map) => {
            this._map = map;
            this._div  = document.createElement('div');
            const div = this._div;
            div.style.position = 'absolute';
            div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
            div.style.backgroundColor = '#EE5D5B';
            div.style.border = '1px solid #bc3b3a';
            div.style.color = 'white';
            div.style.height = '18px';
            div.style.padding = '2px';
            div.style.boxSizing = 'content-box';
            div.style.lineHeight = '18px';
            div.style.whiteSpace = 'nowrap';
            div.style.MozUserSelect = 'none';
            div.style.fontSize = '12px';
            this._span = document.createElement('span');
            const span = this._span;
            div.appendChild(span);
            span.appendChild(document.createTextNode(this._text));
            this._arrow = document.createElement('div');
            const arrow = this._arrow;
            arrow.style.background = 'url(http://map.baidu.com/fwmap/upload/r/map/fwmap/static/house/images/label.png) no-repeat';
            arrow.style.position = 'absolute';
            arrow.style.width = '11px';
            arrow.style.height = '10px';
            arrow.style.top = '22px';
            arrow.style.left = '10px';
            arrow.style.overflow = 'hidden';
            div.appendChild(arrow);
            div.onmouseover = () => {
                this.style.backgroundColor = '#6BADCA';
                this.style.borderColor = '#5188a5';
                arrow.style.backgroundPosition = '0px -20px';
            };
            div.onmouseout = () => {
                this.style.backgroundColor = '#EE5D5B';
                this.style.borderColor = '#bc3b3a';
                arrow.style.backgroundPosition = '0px 0px';
            };
            map.getPanes().labelPane.appendChild(div);
            return div;
        };
        ComplexCustomOverlay.prototype.draw = () => {
            const map = this._map;
            const pixel = map.pointToOverlayPixel(this._point);
            this._div.style.left = `${pixel.x - parseInt(this._arrow.style.left)}px`;
            this._div.style.top = `${pixel.y - 30}px`;
        };
        const id = `map${Math.ceil(Math.random() * 100000)}`;
        $(this.dom).css({
            position: 'relative'
        });
        $('<div class="mapspacer"></div><div class="mapwrapper"></div>').appendTo(this.dom);
        $('.mapwrapper', this.dom).attr('id', id).css({
            height: '100%',
            width: '100%',
            top: 0,
            position: 'absolute'
        });
        $('.mapspacer', this.dom).css({
            height: 0,
            'padding-bottom': `${(this.options.height * 100 / this.options.width)}%`
        });

        const map = new BMap.Map(id);
        map.centerAndZoom(new BMap.Point(this.options.sw, this.options.ne), this.options.zoom);
        map.enableScrollWheelZoom(true);
        if (this.options.mark) {
            const myCompOverlay = new ComplexCustomOverlay(new BMap.Point(this.options.sw, this.options.ne), this.options.mark);
            map.addOverlay(myCompOverlay);
            map.panTo(new BMap.Point(this.options.sw, this.options.ne));
        }
    }
}



/** WEBPACK FOOTER **
 ** ./components/Map/map.js
 **/